export class AudioVolumeCalculator {
    dataBuffer;
    constructor() {
        this.dataBuffer = new Float32Array(32);
    }
    static calculateVolumeFromFloat32Array(dataBuffer) {
        let sumOfSquares = 0;
        for (let i = 0; i < dataBuffer.length; i++) {
            const sample = dataBuffer[i];
            sumOfSquares += sample * sample;
        }
        const rms = Math.sqrt(sumOfSquares / dataBuffer.length);
        const db = 20 * Math.log10(rms);
        const norm = (db + 80) / 50;
        return Math.max(0, Math.min(1, norm));
    }
    calculateVolumeFromAudioFrame(audioFrame) {
        audioFrame.copyTo(this.dataBuffer, {
            planeIndex: 0,
            frameCount: this.dataBuffer.length,
            format: 'f32-planar',
        });
        return AudioVolumeCalculator.calculateVolumeFromFloat32Array(this.dataBuffer);
    }
}
